<script>
import CategoryForm from "@/views/menu/category/categoryForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    categoryService: "categoryService"
  }
})
export default class CategoryDetail extends mixins(CategoryForm) {
  formId = "detail-category-form";

get decoratedElements() {
    return this.allReadonlyFields;
  }

  get fieldColumns() {
    return 2;
  }

  getFormTitle () {
    return this.translations.pageTitles.categories_detail;
  }

  async afterCreate () {
    this.model = await this.categoryService.read(this.$route.params.id);
    this.isReady = true;
  }
}
</script>
